// extracted by mini-css-extract-plugin
export default {"container":"GTcvM","small":"_5pg-3","medium":"tx5Y7","big":"xuD+7","extraBig":"Cq5KR","margin":"+hPrJ","inlineFlex":"xjKYq"};